import type { TToastType } from './toast.types';

const SuccessIcon = () => (
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
		<circle cx="12" cy="12" r="10" fill="#22c55e" />
		<path d="M8 12l3 3 5-6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const ErrorIcon = () => (
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
		<circle cx="12" cy="12" r="10" fill="#e22446" />
		<path d="M15 9l-6 6M9 9l6 6" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
	</svg>
);

const WarningIcon = () => (
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
		<path d="M12 2L2 20h20L12 2z" fill="#f59e0b" />
		<path d="M12 10v4M12 16v1" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
	</svg>
);

const InfoIcon = () => (
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
		<circle cx="12" cy="12" r="10" fill="#06b6d4" />
		<path d="M12 8v0M12 12v4" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
	</svg>
);

const CloseIcon = () => (
	<svg width="16" height="16" viewBox="0 0 20 20" fill="none">
		<path d="M15.8334 5.34163L14.6584 4.16663L10.0001 8.82496L5.34175 4.16663L4.16675 5.34163L8.82508 9.99996L4.16675 14.6583L5.34175 15.8333L10.0001 11.175L14.6584 15.8333L15.8334 14.6583L11.1751 9.99996L15.8334 5.34163Z" fill="#6A6977" />
	</svg>
);

const TOAST_ICON_BY_TYPE: Record<TToastType, JSX.Element> = {
	success: <SuccessIcon />,
	error: <ErrorIcon />,
	warning: <WarningIcon />,
	info: <InfoIcon />
};

export { CloseIcon, TOAST_ICON_BY_TYPE };
